class RatingStore {
    constructor() {
        //WARNING : ADD VARIABLES TO DEFAULT_FILTERS BELOW (USEFULL FOR LOGOUT RESET FILTERS)
        this.filters = {
            author_identification: '',
            search: '',
            in: '',
            sharedRatings: [],
            units: [],
            unit_groups: [],
            questions_answers: [],
            dates: [],
            rating_categories: {
                emotion: [],
                theme: [],
                context: []
            },
            weighted_sentiment: [],
            nps: [0, 10],
            has_answers: [],
            has_comment: '',
            voice_transcript: '',
            standard_rating_ranges: [0, 100],
            consumer_influence: [0, 100],
            categorized_by: [],
            interesting_updated_by: [],
            interesting: 0,
            language: [],
            channels: [],
            excluded_channels: [],
            sortBy: 'posted_at_updated',
            with: [
                'data',
                'answers',
                'contents.question',
                'contents.mentions.ratingCategories',
                'consumer',
                'questionAnswers.question',
                'channels'
            ],
            with_fractal: [
                'data',
                'answers',
                'contents.question',
                'contents.mentions.ratingCategories.rating_mentions_rating_categories_pivot',
                'consumer',
                'place',
                'channels',
                'questionAnswers.question'
            ]
        };

        this.default_filters = {
            author_identification: '',
            search: '',
            in: '',
            sharedRatings: [],
            units: [],
            unit_groups: [],
            questions_answers: [],
            dates: [],
            rating_categories: {
                emotion: [],
                theme: [],
                context: []
            },
            weighted_sentiment: [],
            nps: [0, 10],
            has_answers: [],
            has_comment: '',
            voice_transcript: '',
            standard_rating_ranges: [0, 100],
            consumer_influence: [0, 100],
            categorized_by: [],
            interesting_updated_by: [],
            interesting: 0,
            language: [],
            channels: [],
            excluded_channels: [],
            sortBy: 'posted_at_updated',
            with: [
                'data',
                'answers',
                'contents.question',
                'contents.mentions.ratingCategories',
                'consumer',
                'questionAnswers.question',
                'channels'
            ],
            with_fractal: [
                'data',
                'answers',
                'contents.question',
                'contents.mentions.ratingCategories.rating_mentions_rating_categories_pivot',
                'consumer',
                'place',
                'channels',
                'questionAnswers.question'
            ]
        };

        this.inappropriateGroupsWithReasons = [];
        this.page = 1;
        this.cursor = null;
        this.nextCursor = null;
        this.prevCursor = null;
        this.cursorStack = [null];
        this.cursorIndex = 0;
        this.ratingsToShare = [];
        this.questionsToSearch = [];
        this.ratingsToShareHasComment = false;
        this.hasAppliedFilters = false;
    }
}

export default new RatingStore();
